'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DuplicateSavedSearch = require('./components/DuplicateSavedSearch.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DuplicateSavedSearch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/saved-search/lib/components/duplicate-saved-search/index.js
// module id = 542
// module chunks = 1